let Quotes=[
  {
    "Year": "1940s",
    "NotesEN": "was the first UN Secretary General",
    "person1EN": "Trygve Halvdan Lie",
    "person2EN": "Elvis Presley",
    "person3EN": "Winston Churchill",
    "quoteEN": "Those who gave their lives in order that we may be free, those who lost their homes, those who suffered, and still suffer, from the consequences of war have given us a sacred mandate: that is, to build a firm foundation for the peace of the world.",
    "NotesAR": "أول أمين عام للأمم المتحدة",
    "person1AR": "تريغفه هالفدان لي",
    "person2AR": "ألفيس بريسلي ",
    "person3AR": "وينستون تشيرشل ",
    "quoteAR": "إن الذين ضحوا بأرواحهم لكي ننعم بالحرية، والذين فقدوا منازلهم وعانوا وما زالوا يعانون من عواقب الحرب، قد منحونا مهمة مقدسة هي بناء بأساس متين للسلام العالمي."
  },
  {
    "Year": "1950s",
    "NotesEN": "was the USSR leader from 1953 to 1964",
    "person1EN": "Nikita Khrushchev",
    "person2EN": "Gamel Abdel Nasser",
    "person3EN": "Josef Stalin",
    "quoteEN": "I happened to read recently a remark by the American nuclear physicist W. Davidson, who noted that the explosion of one hydrogen bomb releases a greater amount of energy than all the explosions set off by all countries in all wars known in the entire history of mankind. And he, apparently, is right.",
    "NotesAR": "زعيم الاتحاد السوفياتي (1953-1964)",
    "person1AR": "نيكيتا خروتشوف",
    "person2AR": "جمال عبد الناصر",
    "person3AR": "جوزيف ستالين ",
    "quoteAR": "قرأت أخيرًا تصريحا للعالم الفيزيائي النووي الأميركي دبليو ديفدسون، أشار فيه إلى أن انفجار قنبلة هيدروجينية واحدة يولّد قدرا من الطاقة يفوق ما ولدته جميع الانفجارات التي أطلقتها كل البلدان خلال جميع الحروب المعروفة في تاريخ البشرية، وأعتقد أنه على حق."
  },
  {
    "Year": "1960s",
    "NotesEN": "was US president from 1961 to 1963",
    "person1EN": "John F. Kennedy",
    "person2EN": "Martin Luther King",
    "person3EN": "General Ayub Khan",
    "quoteEN": "The mere existence of modern weapons, ten million times more powerful than any that the world has ever seen, and only minutes away from any target on Earth is a source of horror, and discord and distrust.",
    "NotesAR": "رئيس الولايات المتحدة من 1961 إلى 1963",
    "person1AR": "جون كينيدي ",
    "person2AR": "مارتن لوثر كينغ",
    "person3AR": "الجنرال أيوب خان",
    "quoteAR": "إن مجرد وجود أسلحة حديثة، أقوى بعشرة ملايين مرة من أي أسلحة شهدها العالم من قبل على بعد دقائق فقط من أي هدف على وجه الأرض، يعد مصدرا للرعب والخلاف وعدم الثقة."
  },
  {
    "Year": "1970s",
    "NotesEN": "was the chairman of the Palestinian Liberation Organization from 1969 to 2004",
    "person1EN": "Yasser Arafat",
    "person2EN": "Mao Zedong",
    "person3EN": "Menachem Begin",
    "quoteEN": "I have come bearing an olive branch in one hand and the freedom fighter's gun in the other. Do not let the olive branch fall from my hands.",
    "NotesAR": "رئيس منظمة التحرير الفلسطينية من 1969 إلى 2004",
    "person1AR": "ياسر عرفات",
    "person2AR": "أنور السادات",
    "person3AR": "مناحيم بيغن",
    "quoteAR": "جئتكم يا سيادة الرئيس.. ببندقية الثائر في يدي، وبالأخرى غصن الزيتون، فلا تسقطوا الغصن الأخضر من يدي، لا تسقطوا الغصن الأخضر من يدي، لا تسقطوا الغصن الأخضر من يدي.."
  },
  {
    "Year": "1980s",
    "NotesEN": "was British Prime Minister from 1979 to 1990",
    "person1EN": "Margaret Thatcher",
    "person2EN": "Billie Jean King",
    "person3EN": "Mikhail Gorbchev",
    "quoteEN": "The environmental challenge which confronts the whole world demands an equivalent response from the whole world. Every country will be affected and no one can opt out. ",
    "NotesAR": "رئيسة الوزراء البريطانية من 1979 إلى 1990",
    "person1AR": "مارغريت تاتشر",
    "person2AR": "بيلي جين كينغ ",
    "person3AR": "ميخائيل سيرغيفيتش غورباتشوف",
    "quoteAR": "إن التحدي البيئي الذي يواجه الكون بأسره يتطلب استجابة تناسب حجمه من العالم بأسره، لأن كل الدول ستتأثر به دون استثناء."
  },
  {
    "Year": "1990s",
    "NotesEN": "was South Africa's president from 1994 to 1999",
    "person1EN": "Nelson Mandela",
    "person2EN": "Malcolm X",
    "person3EN": "Rajiv Gandhi",
    "quoteEN": "It will forever remain an indelible blight on human history that the apartheid crime ever occurred.",
    "NotesAR": "رئيس جنوب أفريقيا من 1994 إلى 1999",
    "person1AR": "نيلسون مانديلا",
    "person2AR": "مالكوم إكس ",
    "person3AR": "راجيف غاندي ",
    "quoteAR": "وجود نظام الفصل العنصري سيبقى وصمة عار لا تمحى في تاريخ البشرية."
  },
  {
    "Year": "2000s",
    "NotesEN": "was Venezuela's president from 1999 to 2013",
    "person1EN": "Hugo Chavez",
    "person2EN": "George W. Bush",
    "person3EN": "Pope Francis",
    "quoteEN": "The devil came here yesterday, and it smells of sulphur still today.",
    "NotesAR": "رئيس فنزويلا من 1999 إلى 2013",
    "person1AR": "هوغو شافيز",
    "person2AR": "جورج بوش ",
    "person3AR": "باراك أوباما ",
    "quoteAR": "بالأمس، جاء الشيطان إلى هنا، ولذلك فإن رائحة الكبريت لا تزال تفوح من المكان حتى اليوم."
  },
  {
    "Year": "2010s",
    "NotesEN": "is the current president of Bolivia",
    "person1EN": "Evo Morales",
    "person2EN": "Xi Jinping",
    "person3EN": "Donald Trump",
    "quoteEN": "The only way to end poverty and all the other serious problems facing humankind is to do away with capitalism.",
    "NotesAR": "الرئيس الحالي لبوليفيا ",
    "person1AR": "إيفو موراليس ",
    "person2AR": "فيدل كاسترو",
    "person3AR": "دونالد ترامب ",
    "quoteAR": "الطريقة الوحيدة للقضاء على الفقر وجميع المشاكل الخطيرة الأخرى التي تواجه البشرية، هي التخلص من الرأسمالية."
  }
]
export default Quotes